(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ots-motion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ots-motion'))customElements.define('ots-motion',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelector('.ots-motion-toggle')?.addEventListener('click',event=>{const paused=this.classList.toggle('is-paused');event.currentTarget.setAttribute('aria-pressed',String(paused));});}});

  } catch(e) { console.error(e); }
})();
})();
